module.exports = __webpack_public_path__ + "static/media/automat_symbol.7d051aee.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/automat_symbol.png
// module id = 387
// module chunks = 0